export function displayError(key: string, value: unknown): string {
  switch (key) {
    case 'required':
      return $localize`:@@Common.error.required:Required`;
    case 'email':
      return $localize`:@@Common.error.email:Email address is invalid.`;
    case 'minlength':
      return $localize`:@@Common.error.min-length:Minimum length is ${(value as { requiredLength: number }).requiredLength}.`;
    case 'maxlength':
      return $localize`:@@Common.error.max-length:Maximum length is ${(value as { requiredLength: number }).requiredLength}.`;
    case 'pattern':
      return $localize`:@@Common.error.pattern:Has to match pattern ${(value as { requiredPattern: string }).requiredPattern}.`;
    case 'min':
      return $localize`:@@Common.error.min:Minimum value is ${(value as { min: number }).min}.`;
    case 'max':
      return $localize`:@@Common.error.max:Maximum value is ${(value as { max: number }).max}.`;
    default:
      console.assert(typeof value === 'string', 'Unhandled error type', key, value);
      return String(value);
  }
}
